export default __webpack_public_path__ + "static/media/lawyerComic.002de423.png";